import * as util from "./util";

export default (fetch) => {
  return {
    async view(info) {
      let baseURL = '//' + (window.$bili_arcopen.isUAT ? 'uat-' : '') + 'api.bilibili.com'
      const {data} = await fetch.get(baseURL + '/x/feedback/web/session/reply', {
          params: {
              ...info,
              platform: 'open-platform'
          }
      })
      if (data.code === 0) {
          return data.data
      } else {
          throw new Error('工单查询失败')
      }
    },
    // user-应用查询-列表
    async viewList(info) {
        let baseURL = '//' + (window.$bili_arcopen.isUAT ? 'uat-' : '') + 'api.bilibili.com'
        const {data} = await fetch.get(baseURL + '/x/feedback/web/session', {
            params: {
                ...info,
                platform: 'open-platform'
            }
        })
        if (data.code === 0) {
            return data
        } else {
            throw new Error('查询工单列表失败')
        }
    },
    async sendReply(msg){
        let baseURL = '//' + (window.$bili_arcopen.isUAT ? 'uat-' : '') + 'api.bilibili.com'
        const {data} = await fetch.post(baseURL + '/x/feedback/web/add', {
            ...msg
        }, {
            not_json: true
        })
        return data
    },
    async upload(file) {
      const form = new FormData()
      form.append('file', file)
      const {data} = await fetch.post(`//${window.$bili_arcopen.isUAT ? 'uat-' : ''}api.bilibili.com/x/feedback/web/upload?csrf=${util.getCookie('bili_jct')}`, form)
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    async add (body) {
      const { data } = await fetch.post(`//${window.$bili_arcopen.isUAT ? 'uat-' : ''}api.bilibili.com/x/feedback/web/add?csrf=${util.getCookie('bili_jct')}`, body)
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    async tag () {
      const { data } = await fetch.get(`//${window.$bili_arcopen.isUAT ? 'uat-' : ''}api.bilibili.com/x/feedback/platform/tag`, {
        params: {
          business: 'open-platform'
        }
      })
      return data.data
    }
  }
}
